import React from "react"
import Cabecalho from "../Cabecalho"
import { EmissoesParaMeuCNPJContent } from "./components/EmissoesParaMeuCNPJContent"

export function EmissoesParaMeuCNPJ() {
    return (
        <>
            <Cabecalho pagina="Emissões para meu CNPJ" />
            <EmissoesParaMeuCNPJContent />
        </>
    )
}
